import { cva } from "class-variance-authority";

interface LoaderProps {
  size?: "sm" | "md" | "lg";
}

export default function Loader({ size = "md" }: LoaderProps) {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className={loaderStyles({ variant: size })}>
        <div className="absolute inset-0 rounded-full border-[4px] border-zinc-200"></div>
        <div className="absolute inset-0 animate-spin rounded-full border-[4px] border-t-0 border-blue-300"></div>
      </div>
    </div>
  );
}

const loaderStyles = cva("relative aspect-square rounded-full", {
  variants: {
    variant: {
      sm: "w-5",
      md: "w-7",
      lg: "w-10",
    },
    defaultVariants: {
      variant: "md",
    },
  },
});
